/**
 * Template loader for native HTML <template> elements
 * Templates are embedded in index.html by Vite plugin at build time
 */
export class TemplateLoader {
  /**
   * Clone a screen template and return the DocumentFragment
   */
  cloneScreen(screenName: string): DocumentFragment | null {
    const templateId = `template-screen-${screenName}`;
    const template = document.getElementById(templateId) as HTMLTemplateElement;

    if (!template) {
      console.error(`[TemplateLoader] Screen template not found: ${templateId}`);
      return null;
    }

    return template.content.cloneNode(true) as DocumentFragment;
  }

  /**
   * Clone a component template
   */
  cloneComponent(componentName: string): DocumentFragment | null {
    const templateId = `template-component-${componentName}`;
    const template = document.getElementById(templateId) as HTMLTemplateElement;

    if (!template) {
      console.error(`[TemplateLoader] Component template not found: ${templateId}`);
      return null;
    }

    return template.content.cloneNode(true) as DocumentFragment;
  }

  /**
   * Check if a screen template exists
   */
  hasScreenTemplate(screenName: string): boolean {
    const templateId = `template-screen-${screenName}`;
    return document.getElementById(templateId) !== null;
  }

  /**
   * Check if a component template exists
   */
  hasComponentTemplate(componentName: string): boolean {
    const templateId = `template-component-${componentName}`;
    return document.getElementById(templateId) !== null;
  }

  /**
   * Get list of all available screen template IDs
   */
  getAvailableScreens(): string[] {
    const templates = document.querySelectorAll('template[id^="template-screen-"]');
    return Array.from(templates).map(t => t.id.replace('template-screen-', ''));
  }

  /**
   * Get list of all available component template IDs
   */
  getAvailableComponents(): string[] {
    const templates = document.querySelectorAll('template[id^="template-component-"]');
    return Array.from(templates).map(t => t.id.replace('template-component-', ''));
  }
}

export const templateLoader = new TemplateLoader();
